// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { Card } from '@gandi/ui/deprecated';

import { CallToActionFooter } from './CallToActionFooter';

import styles from './CallToAction.scss';

const noMarginBottom = { marginBottom: 0 };

export function CallToAction(): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <Card className={styles.root} footer={<CallToActionFooter />}>
      <h3 style={noMarginBottom}>{__('Continue shopping')}</h3>
    </Card>
  );
}
